export default __webpack_public_path__ + "static/media/group-631@3x.d2c36d4f.png";